// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React, {memo} from 'react';

import {FileInfo} from 'mattermost-redux/types/files';
import {Post} from 'mattermost-redux/types/posts';
import {useStatist} from '@time-webkit/statist';

import FilePreviewModalInfo from '../file_preview_modal_info/file_preview_modal_info';
import FilePreviewModalMainActions from '../file_preview_modal_main_actions/file_preview_modal_main_actions';
import {isFileInfo, LinkInfo} from '../types';

import './file_preview_modal_footer.scss';

interface Props {
    fileInfo: FileInfo | LinkInfo;
    filename: string;
    post?: Post;
    fileURL: string;
    showPublicLink?: boolean;
    enablePublicLink: boolean;
    canDownloadFiles: boolean;
    isExternalFile: boolean;
    handleModalClose: () => void;
}

const FilePreviewModalFooter: React.FC<Props> = ({post, ...actionProps}: Props) => {
    const {sendToStatist} = useStatist();

    return (
        <div className='file-preview-modal-footer'>
            <FilePreviewModalInfo
                showFileName={false}
                post={post}
                filename={actionProps.filename}
            />
            <FilePreviewModalMainActions
                {...actionProps}
                showClose={false}
                usedInside='Footer'
                showOnlyClose={false}
                onDownload={() => {
                    if (isFileInfo(actionProps.fileInfo) && post) {
                        sendToStatist('app.fileDownloaded', {
                            channelid: post.channel_id,
                            messageId: post.id,
                            fileId: (actionProps.fileInfo as FileInfo).id,
                        });
                    }
                }}
            />
        </div>
    );
};
export default memo(FilePreviewModalFooter);
